import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import ForgotPasswordLink from '../components/ForgotPasswordLink';
import PasswordInput from '../components/PasswordInput';
import { signUpMarketplace } from '../lib/auth';
import { useAuth } from '../authContext';
import { theme } from '../lib/theme';

export default function MarketplaceRegister() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [searchParams] = useSearchParams();
  const defaultRole = searchParams.get('role') === 'driver' ? 'driver' : 'passenger';

  const [role, setRole] = useState(defaultRole);
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const { error: err } = await signUpMarketplace(email, password, fullName, phone, role);
      if (err) {
        setError(err.message);
        return;
      }
      await refresh();
      if (role === 'driver') {
        navigate('/marketplace/driver/apply', { replace: true });
      } else {
        navigate('/marketplace/passenger', { replace: true });
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={{ minHeight: '100vh', background: theme.bg, color: theme.text, fontFamily: theme.font, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ width: '100%', maxWidth: 420 }}>
        <Link to="/" style={{ textDecoration: 'none', color: theme.text, fontWeight: 700, fontSize: 18 }}>
          ← Transport Team
        </Link>
        <h1 style={{ fontSize: 24, fontWeight: 800, marginTop: 24, marginBottom: 8 }}>Create account</h1>
        <p style={{ color: theme.muted, marginBottom: 20, fontSize: 14 }}>Book drivers or apply to drive</p>

        <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
          {['passenger', 'driver'].map((r) => (
            <button
              key={r}
              type="button"
              onClick={() => setRole(r)}
              style={{
                flex: 1,
                padding: 10,
                borderRadius: 8,
                border: role === r ? `2px solid ${theme.accent}` : '1px solid rgba(255,255,255,0.1)',
                background: role === r ? 'rgba(13,115,119,0.15)' : 'transparent',
                color: theme.text,
                cursor: 'pointer',
                textTransform: 'capitalize',
              }}
            >
              {r}
            </button>
          ))}
        </div>

        <form onSubmit={handleSubmit}>
          <input required value={fullName} onChange={(e) => setFullName(e.target.value)} placeholder="Full name" style={inputStyle} />
          <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" style={{ ...inputStyle, marginTop: 10 }} />
          <input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Phone" style={{ ...inputStyle, marginTop: 10 }} />
          <PasswordInput
            required
            minLength={8}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password (8+ chars)"
            style={{ marginTop: 10 }}
            inputStyle={inputStyle}
            autoComplete="new-password"
            toggleColor={theme.muted}
          />
          <ForgotPasswordLink scope="marketplace" linkColor={theme.accentLight} />
          {error && <p style={{ color: '#f87171', fontSize: 14, marginTop: 12 }}>{error}</p>}
          <button type="submit" disabled={busy} style={{ marginTop: 20, width: '100%', padding: 14, background: theme.accent, color: '#fff', border: 'none', borderRadius: 10, fontWeight: 700, cursor: 'pointer' }}>
            {busy ? 'Creating…' : 'Create account'}
          </button>
        </form>
        <p style={{ marginTop: 20, fontSize: 14, color: theme.muted, textAlign: 'center' }}>
          <Link to="/marketplace/login" style={{ color: theme.accentLight }}>Sign in</Link>
        </p>
      </div>
    </div>
  );
}

const inputStyle = {
  width: '100%',
  boxSizing: 'border-box',
  padding: '12px 14px',
  borderRadius: 10,
  border: '1px solid rgba(255,255,255,0.12)',
  background: theme.bg1,
  color: theme.text,
  fontSize: 15,
};
